var map = {
	"./arrowhead.png": 214,
	"./bottle.png": 215,
	"./bracelet.png": 216,
	"./coastal.png": 217,
	"./coin.png": 218,
	"./cups.png": 219,
	"./day_1.png": 220,
	"./day_2.png": 221,
	"./day_3.png": 222,
	"./ear-rings.png": 223,
	"./earring.png": 224,
	"./egg.png": 225,
	"./flower.png": 226,
	"./fossils.png": 227,
	"./heirlooms.png": 228,
	"./hide.png": 229,
	"./jewelry.png": 230,
	"./megafauna.png": 231,
	"./metal-detector.png": 232,
	"./nazar.png": 233,
	"./necklace.png": 234,
	"./oceanic.png": 235,
	"./pentacles.png": 236,
	"./plants.png": 237,
	"./random.png": 238,
	"./ring.png": 239,
	"./shovel.png": 240,
	"./show.png": 241,
	"./swords.png": 242,
	"./wands.png": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;